/**
 * Option tables for the notifications settings selects, shared so web and
 * native present identical choices (and identical labels) for the same
 * preference enums in `userPreferences.ts`.
 */
export type NotificationSelectOption = { value: string; label: string };

// Quiet hours run on a 30-minute grid: 00:00, 00:30, ... 23:30.
export const HALF_HOUR_TIMES: NotificationSelectOption[] = Array.from({ length: 48 }, (_, i) => {
  const hour = Math.floor(i / 2);
  const minute = i % 2 === 0 ? "00" : "30";
  const period = hour < 12 ? "AM" : "PM";
  const hour12 = hour % 12 === 0 ? 12 : hour % 12;
  return {
    value: `${String(hour).padStart(2, "0")}:${minute}`,
    label: `${hour12}:${minute} ${period}`,
  };
});

// Escalation rung delays, in minutes (stored as the enum's string value).
export const ESCALATION_FIRST_DELAY_OPTIONS: NotificationSelectOption[] = [
  { value: "5", label: "5 minutes" },
  { value: "15", label: "15 minutes" },
  { value: "30", label: "30 minutes" },
  { value: "60", label: "1 hour" },
];

export const ESCALATION_SECOND_DELAY_OPTIONS: NotificationSelectOption[] = [
  { value: "60", label: "1 hour" },
  { value: "120", label: "2 hours" },
  { value: "180", label: "3 hours" },
];

/** Label for a stored option value, falling back to the raw value. */
export const notificationOptionLabel = (
  options: NotificationSelectOption[],
  value: string,
): string => options.find((option) => option.value === value)?.label ?? value;
